import Link from "next/link";
import { useEffect } from "react";
import Layout from "../components/Layout";
import ContentWrapper from "../components/ContentWrapper";
import { WYSIWYG } from "../components/styles/TextStyles";
import { request } from "../lib/datocms";
import { StructuredText } from "react-datocms";
import Image from "next/image";
import Head from "next/head";
import styled from "styled-components";
import { useStore } from "./_app";

const ABOUT_QUERY = `query AboutPage {
  about {
    content {
      value
    }
    aboutImage {
      responsiveImage {
        srcSet
        webpSrcSet
        sizes
        src
        width
        height
        aspectRatio
        alt
        title
        bgColor
        base64
      }
    }
  },
}`;

export async function getStaticProps() {
  const data = await request({
    query: ABOUT_QUERY,
  });
  return {
    props: { data },
  };
}

export default function AboutPage({ data }) {
  const setHeaderOpaque = useStore((state) => state.setHeaderOpaque);

  useEffect(() => {
    setHeaderOpaque();
  }, []);

  return (
    <Layout>
      <Head>
        <title>veikkanen - About</title>
      </Head>
      <ContentWrapper introBuffer={true}>
        <WYSIWYG>
          <StructuredText data={data.about.content} />
        </WYSIWYG>
        <AboutImageWrap>
          <Image
            src={data.about.aboutImage.responsiveImage.src}
            width={data.about.aboutImage.responsiveImage.width}
            height={data.about.aboutImage.responsiveImage.height}
            layout="responsive"
          />
        </AboutImageWrap>
      </ContentWrapper>
    </Layout>
  );
}

const AboutImageWrap = styled.div`
  margin: calc(var(--gridMarginGap) * 4) 0;
`;
